const translateEvent = (stage, e) => {
    let currentNode = stage.eventHelpers.focusManager.getFocusedNode();
    if (!currentNode) {
        currentNode = stage.root.data;
    }
    return {
        cancelBubble: false,
        // Event
        type: e.type,
        currentTarget: currentNode !== null && currentNode !== void 0 ? currentNode : null,
        target: currentNode !== null && currentNode !== void 0 ? currentNode : null,
        originalEvent: e,
    };
};
// https://www.w3.org/TR/uievents/#events-keyboardevents
const dispatchKeyboardEvent = (stage) => {
    return (e) => {
        const translatedEvent = translateEvent(stage, e);
        if (translatedEvent) {
            dispatchVugelKeyboardEvent(translatedEvent);
        }
    };
};
export const dispatchVugelKeyboardEvent = (translatedEvent) => {
    var _a;
    (_a = translatedEvent.target) === null || _a === void 0 ? void 0 : _a.dispatchBubbledEvent(translatedEvent);
};
export const keyboardEventTranslator = {
    keypress: "onKeypress",
    keydown: "onKeydown",
    keyup: "onKeyup",
};
export const setupKeyboardEvents = (targetElement, stage) => {
    for (const key in keyboardEventTranslator) {
        targetElement.addEventListener(key, dispatchKeyboardEvent(stage));
    }
};
//# sourceMappingURL=keyboardEvents.js.map